import { Dispatch } from "redux";
import {QuickbetXReserveActionTypes, QuickbetXReserveAction} from "../../types/QuickbetX/quickbetXReserveTypes";
import axios from "axios";

interface ErrorResponse {
    code: number;
    message: string;
}

export const reserveQuickbetX = (data: any): any => {
    return async (dispatch: Dispatch<QuickbetXReserveAction>) => {
        try {
            dispatch({ type: QuickbetXReserveActionTypes.FETCH_QUICKBET_X_RESERVE_DATA });
            const response = await axios({
                method: 'post',
                url: `/api/quickbetxs/reserve`,
                data: data,
                withCredentials: false
            });
            dispatch({ type: QuickbetXReserveActionTypes.FETCH_QUICKBET_X_RESERVE_DATA_SUCCESS, payload: response.data });
        } catch (error: any) {
            let errorPayload: ErrorResponse;
            if (error.response && error.response.data) {
                const { code, message } = error.response.data;
                errorPayload = { code, message };
            } else {
                errorPayload = { code: -1, message: 'Unknown error occurred' };
            }
            dispatch({ type: QuickbetXReserveActionTypes.FETCH_QUICKBET_X_RESERVE_DATA_ERROR, payload: errorPayload });
        }
    }
}
